






import { Component, Mixins } from "vue-property-decorator";
import { PropertyEditableMixin, NewObjectLocatableMixin } from "./mixins";
import LinePropertyEditor from "./LinePropertyEditor.vue";

@Component({
  components: {
    propertyEditor: LinePropertyEditor,
  },
})
export default class NewLinePropertyEditor extends Mixins(PropertyEditableMixin, NewObjectLocatableMixin) {
  async created(): Promise<void> {
    this.editingSource = await this.createSource();
    this.process = this.layoutLinear;
  }
}
